export default {
  userToken: (state) => state.userToken,
  isAdmin: (state) => state.isAdmin,
  userRoles: (state) => state.userRoles,
  selectedReceptId: (state) => state.selectedReceptId,
  getDialogOpen: (state) => state.dialogOpen,
  level: (state) => state.level,
  isAuthenticated: (state) => !!state.userToken,
  allReceipts: (state) => state.allReceipts,
  receiptId: (state) => state.receiptId,
  vatNumber: (state) => state.vatNumber,
  total: (state) => state.total,
  campaignTitle: (state) => state.currentReceipt.campaignTitle,
  rejectReasons: (state) => state.rejectReasons,
  declineReasons: (state) => state.declineReasons,
  reclaimReasons: (state) => state.reclaimReasons,
  locations: (state) => state.locations,
  autoPilotMode: (state) => state.autoPilotMode,
  dashboarder: (state) => state.dashboarder,
  dashboardersList: (state) => state.dashboardersList,
  campaignsList: (state) => state.campaignsList.reverse(),
  dashboarderStats: (state) => state.dashboarderStats,
  campaign: (state) => state.campaign,
  snackBar: (state) => state.snackBar,
  showSnackBar: (state) => state.showSnackBar,
  isDark: (state) => state.settings.isDark,
  selectedDashboard: (state) => state.selectedDashboard,
  isPending: (state) => state.currentReceipt.isPending,
  isTester: (state) => state.isTester,
  productImageURL: (state) => state.currentReceipt.productImageURL,
  viewedProduct: (state) => state.viewedProduct,
  productImageLength: (state) => state.currentReceipt.productImageURL.length,
  fraudRiskScore: (state) => state.fraudRiskScore,
  fraudModelScore: (state) => state.fraudModelScore,
  fraudResult: (state) => state.currentReceipt.fraudResult,
  processHistory: (state) => state.currentReceipt.processHistory,
  fraudModelWeights: (state) => state.fraudModelWeights,
  reuploadLink: (state) => state.reuploadLink,
  payoutLink: (state) => state.payoutLink,
  selectedRejectReason: (state) => state.selectedRejectReason,
  previewProgress: (state) => state.previewProgress,
  exceptionalItems: (state) => state.exceptionalItems,
  reEvaluateReasons: (state) => state.reEvaluateReasons,
  reEvaluateReasonsService: (state) => state.reEvaluateReasonsService,
  receiptImageFile: (state) => state.receiptImageFile,
};
